module.exports = __webpack_public_path__ + "static/img/图片 74.a013b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/图片 74.png
// module id = wWc6
// module chunks = 1